var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-[10px]"},[_c('div',{staticClass:"title__wrapper relative"},[_c('span',{staticClass:"title__name relative text-[18px] text-[#000] font-500"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subtitle)?_c('span',{staticClass:"title__sub text-xs text-[#62676D] ml-[15px]"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }